setTimeout(() => {
    if (window.innerWidth < 720 ) {
        let dropdownMenuTitle = document.querySelectorAll(".pxu-tabs label.tab-label");

        dropdownMenuTitle.forEach((title, index) => {
            if (index !== 0) {
                title.nextElementSibling.style.height = 0 + "px";
                title.nextElementSibling.style.paddingBottom = 0 + "px";
                title.nextElementSibling.style.paddingTop = 0 + "px";
            } else {
                title.classList.add("active");
            }
            title.addEventListener("click", ()=>{
                if (title.classList.contains("active")) {
                    title.classList.remove("active");
                    title.nextElementSibling.style.height = 0 + "px";
                    title.nextElementSibling.style.paddingBottom = 0 + "px";
                    title.nextElementSibling.style.paddingTop = 0 + "px";
                } else {
                    if (document.querySelector(".pxu-tabs label.tab-label.active")) {
                        dropdownMenuTitle.forEach(title => {
                            title.classList.remove("active");
                            title.nextElementSibling.style.height = 0 + "px";
                            title.nextElementSibling.style.paddingBottom = 0 + "px";
                            title.nextElementSibling.style.paddingTop = 0 + "px";
                        });
                    }
                    title.classList.add("active");
                    title.nextElementSibling.style.height = title.nextElementSibling.scrollHeight + 40 + "px";
                    title.nextElementSibling.style.paddingTop = "1.35rem";

                    setTimeout(() => {
                        title.scrollIntoView({
                            behavior: 'auto',
                            block: 'start',
                            inline: 'center'
                        });
                    }, 110);
                }
            })
        });
    }
}, 1);